// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2OzVX","info":"Note_info__39-tt","note":"Note_note__2PmXl","actions":"Note_actions__nuHos"};